/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getYesNoCodetableUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getCodetablesByTableNameUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getNotificationTypeCodetableUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getGenderCodetableUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

/**
 * Gets CodeTable from api:
 * /v1/codetables/{table_name}
 *
 * @param {string} table_name.
 * @param {any} callback function to call once this function has finished
 */
const getStateCodetableUtil = (table_name, callback) => {
  ReduxUtils.getModelDataFromRestAPI(callback, `v1/codetables/${table_name}`, models.CodeTable);
};

export {
  getYesNoCodetableUtil,
  getCodetablesByTableNameUtil,
  getNotificationTypeCodetableUtil,
  getGenderCodetableUtil,
  getStateCodetableUtil,
};
